import React from 'react';
import AdminNavbar from './Admin-navbar';

function LayoutEditor() {
  return (
    <>
    <div>
        <AdminNavbar />
    </div>
    <div>
      this is layout editor
    </div>
    </>
  );
}

export default LayoutEditor;
